import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../services/user.service';

/**
 * Component for managing user cookies.
 */
@Component({
	selector: 'cookies',
	templateUrl: './cookies.component.html',
	styleUrl: './cookies.component.css'
})
export class CookiesComponent implements OnInit {

	LOCALIZATION: any;

	gaCookieAllowed: boolean = false;

	constructor(
		private userService: UserService,
		private ngbmodalService: NgbActiveModal
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;

		let userData = this.userService.getLocalStorageData();
		this.gaCookieAllowed = userData.gaCookieAllowed;
	}

	/**
	 * Saves the user's cookie choices.
	 */
	save(): void {
		//TODO: turn off non essential cookies once they are implemented;

		let userData = this.userService.getLocalStorageData();
		userData.cookieClosed = true;
		userData.gaCookieAllowed = this.gaCookieAllowed;
		this.userService.setLocalStorageData(userData);

		this.proceed();
	}

	/**
	 * Closes the modal, returning a result of ok and payload.
	 */
	proceed(): void {
		let caller = {
			callerName: 'cookies'
		};

		this.ngbmodalService.close({
			result: { answer: 'ok', caller: caller },
			timestamp: new Date(),
		});
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbmodalService.dismiss();
	}
}
